import React, { useEffect, useState } from "react";
import { PageHeader, Toast, Modal } from "@/components/Layout";
import api from "@/lib/api";
import Select from "@/components/Select";
import { useAuth } from "@/context/AuthContext";
import { lock } from "@/lib/perm";

export default function Holidays() {
  const { has } = useAuth();
  const [cfg, setCfg] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());
  const [cal, setCal] = useState(null);
  const [editing, setEditing] = useState(null);
  const [msg, setMsg] = useState({text:"",type:"info"});

  const load = async () => {
    const c = await api.get("/config"); setCfg(c.data);
    const y = c.data?.planning_year || new Date().getFullYear();
    setYear(y);
  };
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (year) api.get(`/mdm/holidays/${year}`).then(r => setCal(r.data));
  }, [year]);

  const seedRo = async () => {
    try { await api.post(`/mdm/holidays/seed-ro/${year}`);
      const r = await api.get(`/mdm/holidays/${year}`); setCal(r.data);
      setMsg({text:`Calendar RO ${year} generat`,type:"success"}); setTimeout(()=>setMsg({text:""}),1500);
    } catch(e) { setMsg({text:e?.response?.data?.detail||"Eroare",type:"error"}); }
  };
  const save = async () => {
    try { await api.put(`/mdm/holidays/${year}`, { year, days: editing.days });
      const r = await api.get(`/mdm/holidays/${year}`); setCal(r.data);
      setEditing(null); setMsg({text:"Salvat",type:"success"}); setTimeout(()=>setMsg({text:""}),1500);
    } catch(e) { setMsg({text:e?.response?.data?.detail||"Eroare",type:"error"}); }
  };

  const addDay = () => setEditing({...editing, days: [...(editing.days||[]), {date:"", name:""}]});
  const updDay = (i, k, v) => { const a = [...editing.days]; a[i] = {...a[i], [k]: v}; setEditing({...editing, days: a}); };
  const rmDay = (i) => { const a = [...editing.days]; a.splice(i,1); setEditing({...editing, days: a}); };

  return (
    <>
      <PageHeader title="Sărbători Legale" subtitle={`Aplicabile global tuturor rapoartelor de muncă · Anul de programare: ${cfg?.planning_year || year}`}
        actions={<>
          <Select className="select" style={{width:100}} value={year} onChange={e=>setYear(parseInt(e.target.value))} data-testid="hol-year">
            {[year-1, year, year+1, year+2].map(y=><option key={y}>{y}</option>)}
          </Select>
          <button className="btn btn-secondary" onClick={seedRo} data-testid="seed-ro" {...lock(has("holidays.seed"))}>Generează RO {year}</button>
          <button className="btn btn-primary" onClick={()=>setEditing({days: cal?.days || []})} data-testid="edit-hol" {...lock(has("holidays.update"))}>Editează</button>
        </>} />
      <Toast msg={msg.text} type={msg.type} />
      <div className="card" style={{padding:24}}>
        <div style={{fontSize:11,color:"var(--blue-primary)",fontWeight:700,letterSpacing:"0.05em",textTransform:"uppercase"}}>Anul {year}</div>
        <div style={{fontSize:15,color:"var(--navy)",marginTop:4}}>{cal?.days?.length || 0} zile de sărbătoare configurate</div>
        <div style={{marginTop:14,display:"flex",flexWrap:"wrap",gap:6}}>
          {(cal?.days || []).sort((a,b)=>a.date.localeCompare(b.date)).map((d,i)=>(
            <span key={i} className="badge badge-active" title={d.name}
              style={{fontFamily:"IBM Plex Sans",textTransform:"none",letterSpacing:"normal"}}>
              {d.date.slice(5)} · {d.name}
            </span>
          ))}
        </div>
        {!cal && <div style={{color:"#94A3B8",marginTop:12,fontSize:13}}>{`Niciun calendar pentru ${year}. Apasă "Generează RO ${year}".`}</div>}
      </div>
      {editing && (
        <Modal title={`Editează sărbători ${year}`} onClose={()=>setEditing(null)} width={640}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
            <div style={{fontSize:12,fontWeight:700,color:"#64748B",textTransform:"uppercase"}}>Zile</div>
            <button className="btn btn-secondary" style={{padding:"3px 10px",fontSize:12}} onClick={addDay}>+ Adaugă</button>
          </div>
          <div style={{display:"grid",gap:6,maxHeight:340,overflow:"auto"}}>
            {(editing.days||[]).map((d,i)=>(
              <div key={i} style={{display:"grid",gridTemplateColumns:"140px 1fr auto",gap:8}}>
                <input className="input" type="date" value={d.date} onChange={e=>updDay(i,"date",e.target.value)} />
                <input className="input" value={d.name} onChange={e=>updDay(i,"name",e.target.value)} />
                <button className="btn btn-danger" style={{padding:"3px 10px",fontSize:12}} onClick={()=>rmDay(i)}>×</button>
              </div>
            ))}
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:16}}>
            <button className="btn btn-secondary" onClick={()=>setEditing(null)}>Anulează</button>
            <button className="btn btn-primary" onClick={save} data-testid="save-hol" {...lock(has("holidays.update"))}>Salvează</button>
          </div>
        </Modal>
      )}
    </>
  );
}
